import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  changed: {
    marginBottom: theme.footerHeight + 50
  }
});

export default makeStyles(styles);
